import { useNavigate, useParams } from "react-router";
import MyContext from "../../context/Context";
import { useContext, useEffect, useState } from "react";
import { Timestamp, doc, getDoc, setDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import toast from "react-hot-toast";
import Loader from "../../components/Loader/Loader";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const categoryList = [
  { name: "select" },
  { name: "plant" },
  { name: "laptop" },
];

const UpdateProduct = () => {
  const context = useContext(MyContext);
  const { loading, setLoading, getAllProductFunction } = context;
  const navigate = useNavigate();
  const { id } = useParams();

  const [product, setProduct] = useState({
    title: "",
    price: "",
    productImageUrl: [],
    category: "",
    description: "",
    quantity: 1,
    time: Timestamp.now(),
    date: new Date().toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }),
  });

  const [imageFiles, setImageFiles] = useState([]);

  useEffect(() => {
    getSingleProductFunction();
  }, []);

  const getSingleProductFunction = async () => {
    setLoading(true);
    try {
      const productTemp = await getDoc(doc(fireDB, "products", id));
      const productData = productTemp.data();
      setProduct({
        ...productData,
        productImageUrl: Array.isArray(productData?.productImageUrl)
          ? productData.productImageUrl
          : productData?.productImageUrl
            ? [productData.productImageUrl]
            : [],
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to load product");
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const newFiles = [...imageFiles];
    newFiles[index] = file;
    setImageFiles(newFiles);
  };

  const uploadImagesAndGetUrls = async () => {
    const storage = getStorage();
    const urls = [];

    for (const file of imageFiles) {
      if (file) {
        const storageRef = ref(storage, `productImages/${Date.now()}-${file.name}`);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        urls.push(downloadURL);
      }
    }

    return urls;
  };

  const updateProduct = async () => {
    if (!product.title || !product.price || !product.category || !product.description) {
      return toast.error("All fields are required");
    }

    setLoading(true);
    try {
      const imageUrls = await uploadImagesAndGetUrls();
      const updatedProduct = {
        ...product,
        productImageUrl: [...product.productImageUrl, ...imageUrls],
      };

      await setDoc(doc(fireDB, "products", id), updatedProduct, { merge: true });
      toast.success("Product updated successfully!");
      getAllProductFunction();
      navigate("/adminDashboard");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update product");
    } finally {
      setLoading(false);
    }
  };

  const removeExistingImage = (index) => {
    const updatedUrls = product.productImageUrl.filter((_, i) => i !== index);
    setProduct({ ...product, productImageUrl: updatedUrls });
  };


  useEffect(() => {
    // Scroll to the top when the component loads
    window.scrollTo(0, 0);

}, []);


  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4">
    {loading && (
     <div className="fixed inset-0  bg-opacity-80 z-50 flex items-center justify-center">
       <Loader />
     </div>
   )}
      <div className="bg-white p-8 border border-gray-200 rounded-lg shadow-lg w-full max-w-lg">
        <h2 className="text-center text-2xl font-bold text-gray-700 mb-5">Update Product</h2>

        <input
          type="text"
          value={product.title}
          onChange={(e) => setProduct({ ...product, title: e.target.value })}
          placeholder="Product Title"
          className="input-field"
        />

        <input
          type="number"
          value={product.price}
          onChange={(e) => setProduct({ ...product, price: e.target.value })}
          placeholder="Product Price"
          className="input-field"
        />

        {/* Show existing image URLs with remove option */}
        {product.productImageUrl.map((url, index) => (
          <div key={index} className="mb-2 flex items-center justify-between">
            <img src={url} alt="product" className="w-20 h-20 object-cover rounded-md" />
            <button
              type="button"
              onClick={() => removeExistingImage(index)}
              className="text-red-500 text-sm"
            >
              Remove
            </button>
          </div>
        ))}

        {/* Upload new images */}
        {imageFiles.map((file, index) => (
          <div key={index} className="mb-2">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, index)}
              className="input-field"
            />
            {file && <p className="text-sm text-gray-500">{file.name}</p>}
          </div>
        ))}

        {imageFiles.length < 5 && (
          <button
            type="button"
            onClick={() => setImageFiles([...imageFiles, null])}
            className="mb-4 text-blue-500 underline"
          >
            + Add New Image
          </button>
        )}

        <select
          value={product.category}
          onChange={(e) => setProduct({ ...product, category: e.target.value })}
          className="input-field"
        >
          <option disabled>Select Product Category</option>
          {categoryList.map((value, index) => (
            <option key={index} value={value.name}>
              {value.name}
            </option>
          ))}
        </select>

        <textarea
          value={product.description}
          onChange={(e) => setProduct({ ...product, description: e.target.value })}
          placeholder="Product Description"
          rows="4"
          className="input-field"
        ></textarea>

        <button onClick={updateProduct} type="button" className="btn-submit">
          Update Product
        </button>
      </div>

      <style>{`
        .input-field {
          width: 100%;
          padding: 10px;
          margin-bottom: 10px;
          border: 1px solid #ddd;
          border-radius: 6px;
          outline: none;
        }
        .btn-submit {
          width: 100%;
          background: #007bff;
          color: white;
          padding: 10px;
          border-radius: 6px;
          font-weight: 600;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default UpdateProduct;
